import { render, staticRenderFns } from "./GiftAwayTransactionSummaryReport.vue?vue&type=template&id=052d5e9c"
import script from "./GiftAwayTransactionSummaryReport.vue?vue&type=script&lang=js"
export * from "./GiftAwayTransactionSummaryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports